module.exports = __webpack_public_path__ + "img/clicker.png";